module.exports = "/images/icon-identity.svg?f49850928bf04b75da19969402b339f0";